// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
    production: false,
    hmr: false,
    // apiUrl: 'http://api-buy-help-app-backoffice.local:8083/api/backoffice/v1/'
    apiUrl: 'https://api-app-backoffice-sandbox.buyhelp.com.br/api/backoffice/v1/',
    // apiUrl: 'http://localhost:8083/api/backoffice/v1/',
    // apiUrl: 'https://api-app-backoffice.buyhelp.com.br/api/backoffice/v1/'
    pusher: {
        key: 'a60d91f55d272c7d9c6b',
        cluster: 'sa1',
        forceTLS: true
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
